import {useSearchResultStore} from "~/stores/searchResult.js";
import {useSearchQueryStore} from "@/stores/searchQuery.js";
import {spaceListByAdmin} from "@/api/space";
import {useQueryFormatter} from "@/composables/useQueryFormatter";
import {useRouteQuery} from "@vueuse/router";

export function useAdminSpaceSearch() {
    const searchResultStore = useSearchResultStore()
    const searchQueryStore = useSearchQueryStore()
    const {setSearchQueryToRoute} = useQueryFormatter()
    const _requestId = useRouteQuery('_requestId', '')

    async function handleAdminSpaceSearch(adminId: number, isSetSearchQueryToRoute = false) {
        const queryData = {
            request_id: '',
            admin_id: adminId,
            pagination: {
                "dir": 1,
                "limit": 20,
                "page": 1,
                "sort": "created_date"
            },
        }

        try {
            const res = await spaceListByAdmin(queryData);

            _requestId.value = res.request_id

            if (isSetSearchQueryToRoute) {
                setSearchQueryToRoute(queryData)
            }

            if (res.total > 0) {
                searchResultStore.setSpaceList(res.list)
                searchResultStore.setRequestId(res.request_id)
                searchResultStore.setSpaceListTotal(res.total)
            } else {
                searchResultStore.setSpaceList([])
                searchResultStore.setRequestId('')
                searchResultStore.setSpaceListTotal(0)
            }
        } catch (error) {
            console.log(error);
        }
    }

    return {
        handleAdminSpaceSearch
    }
}
